import ShowTour from './show-tour';

export default ShowTour;
